import { Modal, Button, Form } from 'react-bootstrap';
import { useState } from 'react';
import "./editFile.css";

function EditFileModal({ show, close, file, onSave }) {
    console.log("Edit MODAL", file);
  const [name, setName] = useState(file?.name || '');
  const [type, setType] = useState(file?.type || 'instruction');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...file, name, type });
    close();
  };

  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Редагувати файл</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} className='formEditAdmin'>
          <Form.Group className="mb-3">
            <Form.Label>Назва файлу</Form.Label>
            <Form.Control
              type="text"
              defaultValue={file?.name || ''}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Тип</Form.Label>
            <Form.Control
              as="select"
              defaultValue={file?.type || 'instruction'} onChange={(e) => setType(e.target.value)}
            >
              <option value="instruction">Інструкція</option>
              <option value="manual">Посібник</option>
            </Form.Control>
          </Form.Group>
          <Button variant="secondary" type="submit" className='btnSaveChanges'>
            Зберегти
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditFileModal;